import React, { Suspense } from 'react';
import { EntityContext } from 'context/entityContext';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import CertificationSkeletonLoader from 'components/Certification/CertificationSkeletonLoader';

const Certification = React.lazy(() => import('components/Certification'));

const Certifications: React.FC = () => {
  const ctx = React.useContext(EntityContext);
  const { compareMode } = ctx;
  const isCompare = Boolean(compareMode);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>Certification page do not support compare mode.</Message>
      </Layout.MaxWidth>
    );
  }

  return (
    <div>
      <Suspense fallback={<CertificationSkeletonLoader />}>
        <Certification context={ctx} />
      </Suspense>
    </div>
  );
};

export default Certifications;
